<div class="modal-content">
    <div class="modal-header">
        <h3 class="modal-title pull-left" id="my-modal-title">{{'APPEAL_PETITION_TITLE' | globalTranslate}}</h3>
        <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
            <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon"/>
        </button>
    </div>
    <div class="modal-body">        
        <p [innerHTML]="'APPEAL_PETITION_DESC' | globalTranslate"></p>
    </div>    
    <div class="modal-footer action-container" >
      <!-- [ngClass]="{'action-container':translatedLang === 'sp', 'action-container':translatedLang !== 'sp'}" -->
        <div class="me-2 ml-2" >
          <button type="button" id="dialog1" class="btn d-grid align-items-center btn-secondary" [ngClass]="{'lang-sp': translatedLang === 'sp'}" (click)="uploadProof()">{{
            'UPLOAD_APPEAL_PETITION_BTN' | globalTranslate }}</button>
        </div>
        <div class="me-2 ml-2" >
          <button type="button" id="dialog1" class="btn d-grid align-items-center btn-link" [ngClass]="{'lang-sp': translatedLang === 'sp'}" (click)="appealPetitonForm()">{{ 'PETITION_FORM_BTN' | globalTranslate
            }}</button>
        </div>
      </div>
</div>
